import { render, staticRenderFns } from "./WidgetGlobe.vue?vue&type=template&id=04d8c921&"
import script from "./WidgetGlobe.vue?vue&type=script&lang=js&"
export * from "./WidgetGlobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports